import { createFileRoute } from '@tanstack/react-router';
import { RentalBookingImportPage } from '@/features/rentals/pages/rental-booking-import-page';
import { requireRentalShop } from '@/lib/rental-guard';

export const Route = createFileRoute('/_app/rentals_/import-bookings')({
  beforeLoad: requireRentalShop,
  component: RentalBookingImportPage,
});
